import * as angular from 'angular';

(function () {
    'use strict';
    angular
        .module('app')
        .factory('TradeAndTradeProposals', tradeAndTradeProposalService);

    function tradeAndTradeProposalService($resource, API_URL) {
        return $resource(
            API_URL.TRADE_AND_TRADE_PROPOSAL,
            {
                id: '@id'
            },
            {
                page: { method: 'GET' }
            }
        );
    }
})();
